var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("apeironGwApp.datosHijos.label.requisitosBEX")
                    ),
                  },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-alert", { attrs: { show: "", variant: "primary" } }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("apeironGwApp.datosHijos.label.tabulador")
                    ),
                  },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-overlay",
                {
                  attrs: {
                    show: _vm.isSearching,
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "d-flex justify-content-end" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: !(
                                  _vm.solicitud.estado === "EN_CAPTURA"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.abrirModalAgregar()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.datosHijos.label.agregarHijo"
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "icon-mas" }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: !(
                                  _vm.solicitud.estado === "EN_CAPTURA"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.abrirModalEliminar()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.datosHijos.label.eliminaUltimoHijo"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-table", {
                    staticClass: "text-nowrap mt-3",
                    attrs: {
                      responsive: "",
                      "sticky-header": "70vh",
                      "show-empty": "",
                      "head-variant": "primary",
                      items: _vm.solicitud.datosHijos,
                      fields: _vm.fields,
                    },
                  }),
                  _vm._v(" "),
                  _vm.totalItems > 0
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right",
                              attrs: { sm: "12", md: "12", lg: "12" },
                            },
                            [
                              _c("p", [
                                _c(
                                  "small",
                                  {
                                    staticClass: "text-muted font-weight-bold",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("global.table.totalRows", {
                                          totalRows: _vm.totalItems,
                                        })
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "registroModal",
          attrs: {
            id: "modal-1",
            size: "lg",
            title: _vm.tituloModal,
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: !_vm.isSaving },
                      on: { click: _vm.guardarHijo },
                    },
                    [
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.buttonText) },
                      }),
                      _vm._v(" "),
                      _vm.buttonIcon
                        ? _c("span", { class: _vm.buttonIcon })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.cerrarModal()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.datosHijos.modal.boton.cerrar")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon-cerrar" }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-alert",
            {
              staticClass: "mb-5",
              attrs: { variant: "danger", show: _vm.existenErrores },
            },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("apeironGwApp.datosHijos.modal.errorBusqueda")
                  ),
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.erroresCURP))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.accion !== "E"
                ? _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "fieldset-10",
                            label: _vm.$t(
                              "apeironGwApp.datosHijos.label.curpHijo"
                            ),
                            "label-for": "curpHijo",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-hijo",
                              placeholder: _vm.$t(
                                "apeironGwApp.datosHijos.mensajes.curp"
                              ),
                            },
                            model: {
                              value: _vm.inputCURPHijo,
                              callback: function ($$v) {
                                _vm.inputCURPHijo = $$v
                              },
                              expression: "inputCURPHijo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.accion !== "E"
                ? _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "fieldset-10",
                            label: _vm.$t(
                              "apeironGwApp.datosHijos.label.curpPareja"
                            ),
                            "label-for": "curpPareja",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-pareja",
                              placeholder: _vm.$t(
                                "apeironGwApp.datosHijos.mensajes.curp"
                              ),
                            },
                            model: {
                              value: _vm.inputCURPPareja,
                              callback: function ($$v) {
                                _vm.inputCURPPareja = $$v
                              },
                              expression: "inputCURPPareja",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.accion !== "E"
                ? _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            size: "md",
                            disabled: _vm.isSearching,
                          },
                          on: { click: _vm.buscarCURP },
                        },
                        [
                          !_vm.isSearching
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.datosHijos.acciones.buscar"
                                    )
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isSearching
                            ? _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "save" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSearching
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.datosHijos.acciones.buscando"
                                    )
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSearching
                            ? _c("b-icon", {
                                attrs: {
                                  animation: "spin-pulse",
                                  icon: "arrow-clockwise",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c("input-text", {
                        staticClass: "mb-4",
                        attrs: {
                          id: "nombresCURP",
                          label: _vm.$t("apeironGwApp.datosHijos.grid.nombres"),
                          readonly: true,
                        },
                        model: {
                          value: _vm.$v.personaCurp.nombres.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.personaCurp.nombres, "$model", $$v)
                          },
                          expression: "$v.personaCurp.nombres.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c("input-text", {
                        staticClass: "mb-4",
                        attrs: {
                          id: "apellidoPaternoCURP",
                          label: _vm.$t(
                            "apeironGwApp.datosHijos.grid.apellidoPaterno"
                          ),
                          readonly: true,
                        },
                        model: {
                          value: _vm.$v.personaCurp.apellidoPaterno.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.personaCurp.apellidoPaterno,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.personaCurp.apellidoPaterno.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c("input-text", {
                        staticClass: "mb-4",
                        attrs: {
                          id: "apellidoMaternoCURP",
                          label: _vm.$t(
                            "apeironGwApp.datosHijos.grid.apellidoMaterno"
                          ),
                          readonly: true,
                        },
                        model: {
                          value: _vm.$v.personaCurp.apellidoMaterno.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.personaCurp.apellidoMaterno,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.personaCurp.apellidoMaterno.$model",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c("input-text", {
                        staticClass: "mb-4",
                        attrs: {
                          id: "generoCURP",
                          label: _vm.$t("apeironGwApp.datosHijos.grid.genero"),
                          readonly: true,
                        },
                        model: {
                          value: _vm.$v.personaCurp.genero.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.personaCurp.genero, "$model", $$v)
                          },
                          expression: "$v.personaCurp.genero.$model",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            label: _vm.$t(
                              "apeironGwApp.datosHijos.grid.nacionalidad"
                            ),
                            "label-for": "pais",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "pais",
                              label: _vm.$t(
                                "apeironGwApp.consultaBecas.label.pais"
                              ),
                              options: _vm.catPaises,
                            },
                            model: {
                              value: _vm.$v.personaCurp.paisNacimiento.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.personaCurp.paisNacimiento,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.personaCurp.paisNacimiento.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "4" } },
                    [
                      _c("input-text", {
                        staticClass: "mb-4",
                        attrs: {
                          id: "fechaNacimientoCURP",
                          label: _vm.$t(
                            "apeironGwApp.datosHijos.grid.fechaNacimiento"
                          ),
                          readonly: true,
                        },
                        model: {
                          value: _vm.$v.personaCurp.fechaNacimiento.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.personaCurp.fechaNacimiento,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.personaCurp.fechaNacimiento.$model",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "",
                            label: _vm.$t(
                              "apeironGwApp.datosHijos.grid.parentesco"
                            ),
                          },
                        },
                        [
                          _c("b-form-radio-group", {
                            attrs: {
                              id: "parentescoCURP",
                              options: _vm.parentescoOptions,
                              readonly: true,
                            },
                            model: {
                              value: _vm.$v.personaCurp.parentesco.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.personaCurp.parentesco,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.personaCurp.parentesco.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "confirmacionModal",
          attrs: {
            "header-bg-variant": "primary",
            title: _vm.$t(
              "apeironGwApp.datosHijos.mensajes.tituloConfirmacion"
            ),
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-3",
                              attrs: { variant: "outline-danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.cerrarModalConfirmacion()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon-cerrar" }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("entity.action.close")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-success" },
                              on: {
                                click: function ($event) {
                                  return _vm.aceptarConfirmacion()
                                },
                              },
                            },
                            [
                              [
                                _c("span", { staticClass: "icon-check" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("entity.action.confirm")) +
                                    "\n            "
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          [
            _c(
              "b-row",
              { staticClass: "text-center mt-3" },
              [
                _c("b-col", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "apeironGwApp.datosHijos.mensajes.confirmacion",
                          {
                            accion: _vm.buttonText,
                          }
                        )
                      ),
                    },
                  }),
                ]),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "eliminaHijoModal",
          attrs: {
            id: "modal-1",
            size: "lg",
            title: _vm.tituloModal,
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.eliminarHijo },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.datosHijos.modal.boton.eliminar"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.buttonText) },
                      }),
                      _vm._v(" "),
                      _vm.buttonIcon
                        ? _c("span", { class: _vm.buttonIcon })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.cerrarModalConfirmacionEliminar()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.datosHijos.modal.boton.cerrar")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon-cerrar" }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("span", {
            domProps: {
              textContent: _vm._s(
                _vm.$t("apeironGwApp.datosHijos.label.eliminarHijo")
              ),
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }